import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useIntl } from 'react-intl';

import { styled } from '@mui/material/styles';

import TabContainer from '../../containers/TabContainer/TabContainer';
import ContextStore from '../../modules/context';
import SalesReturnFormTab from './SalesReturnFormTab';

const Root = styled('div')(({ theme }) => ({
  flexGrow: 1,
  backgroundColor: theme.palette.background.paper,
}));

function SalesReturnForm() {
  const { formatMessage } = useIntl()
  const { setBreadcrumbs } = useContext(ContextStore)
  const navigate = useNavigate()
  const location = useLocation()
  const [activeTabIndex, setActiveTabIndex] = useState(undefined);
  const { tabName } = useParams()

  useEffect(() => {
    setBreadcrumbs([{
      text: formatMessage({ id: 'sideMenu.sales.salesReturnForm' })
    }])

    const pathname = location.pathname
    if (pathname === '/sales/salesReturnForm/pending' && activeTabIndex !== 0) {
      setActiveTabIndex(0)
    } else if (pathname === '/sales/salesReturnForm/done' && activeTabIndex !== 1) {
      setActiveTabIndex(1)
    }
    return () => {
    };
  }, [location.pathname]);

  const onTabSelected = (tabIndex) => {
    if (tabIndex === 0) {
      navigate('/sales/salesReturnForm/pending');
    } else if (tabIndex === 1) {
      navigate('/sales/salesReturnForm/done');
    }
  };

  const tabs = [
    { label: formatMessage({ id: 'salesReturnForm.tab.pending' }), component: <SalesReturnFormTab /> },
    { label: formatMessage({ id: 'salesReturnForm.tab.done' }), component: <SalesReturnFormTab /> },
  ]
  const defaultSelect = tabName === 'void' ? 2 : (tabName === 'done' ? 1 : 0)

  return (
    <Root>
      <TabContainer activeTabIndex={activeTabIndex} defaultSelect={defaultSelect} tabs={tabs} onTabSelected={onTabSelected} />
    </Root>
  );
}

export default SalesReturnForm;
